import { useErrorInline } from '@/context/InlineErrorContext/InlineErrorContext';
import { ReceivedInvoiceDetail } from '@/context/services/invoice/type';
import { AiSuggestTag } from '@/features/invoices/components/Details/Components/AiSuggestTag';
import { ViewContextProvider } from '@/features/invoices/components/Details/Components/Context/ViewEdit';
import { InvoiceReports } from '@/features/invoices/components/Details/Components/InvoiceReports';
import { OCRResult } from '@/features/invoices/components/Details/Components/OCRResult/OCRResult';
import { ReceivedInvoiceTransaction } from '@/features/invoices/components/Details/Components/ReceivedInvoiceTransaction';
import { ReconciliationStatus } from '@/features/invoices/components/Details/Components/ReconciliationStatus';
import { hasAiSuggestResult } from '@/features/invoices/utils/aiSuggestStatus';
import { useSplitViewDragging } from '@moneyforward/ap-frontend-components';
import classnames from 'classnames/bind';
import { FC, memo } from 'react';
import { EDocMetadata } from '../EDocMetadata';
import { ReceivedInvoice } from '../ReceivedInvoice';
import { Notification } from './InlineNotification';
import styles from './Right.module.scss';

const cx = classnames.bind(styles);

export type Props = {
  data: ReceivedInvoiceDetail;
};

export const Right: FC<Props> = memo(({ data }) => {
  const { ErrorContextHolder } = useErrorInline();

  const isSplitViewDragging = useSplitViewDragging();

  const aiSuggestStatus = data.ai_suggest_status;

  return (
    <ViewContextProvider>
      <div
        className={cx(styles['container'])}
        // eslint-disable-next-line @moneyforward/account-payable/literals-in-props
        style={{ userSelect: isSplitViewDragging ? 'none' : undefined }}
        data-testid='container'
      >
        <div className={cx(styles['contentContainer'])}>
          <div
            className={cx('notificationContainer', {
              marginBottom24: !hasAiSuggestResult(aiSuggestStatus),
            })}
          >
            <div className={cx(styles['errorContainer'])}>
              {ErrorContextHolder}
            </div>
            <Notification />
          </div>
          <AiSuggestTag aiSuggestStatus={aiSuggestStatus} />
          <div className={cx(styles['content'])}>
            <InvoiceReports data={data.invoice_report} />
            <ReceivedInvoice data={data} />
            <ReconciliationStatus
              data={data.ap_received_invoice_reconciliation}
            />
            <OCRResult data={data} />
            <ReceivedInvoiceTransaction data={data} />
            <EDocMetadata
              receiptType={data.receipt_type ?? undefined}
              eDocMetaDatum={data.mf_file?.e_doc_meta_datum}
            />
          </div>
        </div>
      </div>
    </ViewContextProvider>
  );
});
Right.displayName = 'Right';
